function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'menu';

/**
 * This is the component description.
 */
const Menu = /*#__PURE__*/React.forwardRef(({
  id,
  className: userClassName,
  style,
  items,
  isOpen,
  highlightedIndex,
  getItemProps,
  ...otherProps
}, ref) => /*#__PURE__*/React.createElement("ul", _extends({
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: style,
  ref: ref
}, otherProps), isOpen && items.map((item, index) => /*#__PURE__*/React.createElement("li", _extends({
  key: item.label
}, getItemProps({
  item,
  index
}), {
  className: ['item', highlightedIndex === index && styleNames.modifierActive].filter(Boolean).join(' ')
}), /*#__PURE__*/React.createElement("p", null, item.label)))));
Menu.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The items to be displayed in the menu
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  /**
   * Whether or not the menu is open
   */
  isOpen: PropTypes.bool,
  /**
   * The index of the highlighted item
   */
  highlightedIndex: PropTypes.number,
  /**
   * The function to get the item props
   */
  getItemProps: PropTypes.func
};
Menu.defaultProps = {
  // someProp:false
};
export default Menu;